export default __webpack_public_path__ + "static/media/shopifyExtension2.ad561609.svg";